import { useIntl } from 'react-intl';

import { FocusRingVariants } from '@calm-web/design-system';

import messages from '@/components/purchase/CreditCardForm/messages';
import { usePurchaseParamsState } from '@/hooks/store';

import { SubmitButton } from './styles';

const PaymentElementsFormSubmitButton: React.FC<{
	ctaCopy?: string | ((plan: string | undefined) => string | undefined);
	isDisabled: boolean;
	isLoading: boolean;
	// Optional layout overrides (used by the CS form to size the submit to the Stripe wallet/PayPal
	// buttons and match the group gap). Omitted by the legacy form → design-system defaults.
	height?: string;
	marginTop?: string;
}> = ({ ctaCopy, isDisabled, isLoading, height, marginTop }) => {
	const purchaseParams = usePurchaseParamsState();
	const { formatMessage } = useIntl();

	const getButtonText = (): string => {
		if (ctaCopy) {
			const resolvedCtaCopy = typeof ctaCopy === 'function' ? ctaCopy(purchaseParams?.plan) : ctaCopy;
			if (resolvedCtaCopy) {
				return resolvedCtaCopy;
			}
		}

		if (purchaseParams?.purchaseType?.type === 'freetrial' && purchaseParams.plan !== 'monthly') {
			return formatMessage(messages.startFreeTrial);
		}

		return formatMessage(messages.useCard);
	};

	return (
		<SubmitButton
			data-testid="payment-elements-form-submit-button"
			fullWidth
			backgroundColor="buttonBlue"
			textColor="white"
			focusRingVariant={FocusRingVariants.Dark}
			type="submit"
			isDisabled={isDisabled}
			isLoading={isLoading}
			height={height}
			$marginTop={marginTop}
		>
			{getButtonText()}
		</SubmitButton>
	);
};

export default PaymentElementsFormSubmitButton;
